<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed inset-0 overflow-hidden z-[100]" @close="close">
      <TransitionChild
        as="template"
        enter="ease-in-out duration-500"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in-out duration-100"
        leave-from="opacity-100"
        leave-to="opacity-0"
        style="backdrop-filter: blur(4px);"
      >
        <DialogOverlay
          class="absolute inset-0 bg-opacity-75 transition-opacity"
          style="background: rgba(50, 50, 50, 0.5);"
        />
      </TransitionChild>

      <div class="absolute inset-0 overflow-hidden">
        <DialogOverlay class="absolute inset-0" />

        <div class="fixed inset-y-0 max-w-full right-0 flex">
          <TransitionChild
            as="template"
            enter="transform transition ease-in-out duration-100 sm:duration-300"
            enter-from="translate-x-full"
            enter-to="translate-x-0"
            leave="transform transition ease-in-out duration-100 sm:duration-300"
            leave-from="translate-x-0"
            leave-to="translate-x-full"
          >
            <div
              class="w-screen"
              :style="dynamicWidthStyle"
            >
              <div class="h-full flex flex-col bg-white">
                <div class="bg-gray-900 p-[10px] px-4">
                  <div class="flex items-center justify-between">
                    <DialogTitle class="font-light text-white flex items-center gap-2">
                      <slot name="icon"></slot>
                      {{
                        type === 'create'
                          ? $t('fields.new_slider') + ' ' + title
                          : type === 'update'
                          ? $t('fields.update_slider') + ' ' + title
                          : title
                      }}
                    </DialogTitle>
                    <div class="ml-3 h-7 flex items-center">
                      <button
                        type="button"
                        class="rounded-md text-indigo-200 hover:text-white focus:outline-none focus:ring-2 focus:ring-white"
                        @click="close"
                      >
                        <span class="sr-only">Close</span>
                        <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                </div>

                <div class="h-full min-h-0 px-2">
                  <slot></slot>
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import { XMarkIcon } from '@heroicons/vue/24/outline';
import { LinkIcon, QuestionMarkCircleIcon } from '@heroicons/vue/24/solid';

export default {
  name: 'SliderLarge',

  props: {
    formClose: {
      type: Function,
      default: () => {},
    },
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    type: {
      type: String,
    },
    maxWidth: {
      type: String,
      default: '56rem', // Correspondente a max-w-4xl em Tailwind
    },
    adjustWidth: {
      type: String,
      default: '', // Ajuste adicional, ex: '40px'
    },
  },

  computed: {
    dynamicWidthStyle() {
      if (this.adjustWidth) {
        return `max-width: calc(${this.maxWidth} - ${this.adjustWidth});`;
      }
      return `max-width: ${this.maxWidth};`;
    },
  },

  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    LinkIcon,
    QuestionMarkCircleIcon,
    XMarkIcon,
  },

  methods: {
    close() {
      this.formClose();
    },
  },
};
</script>

<style scoped>
/* Adicional, se necessário */
</style>
